export default "__VITE_ASSET__d502036d__"